module.exports = __webpack_public_path__ + "static/media/help.1ca047c3.png";